<!--
 * @Description: 
 * @Author: Chp
 * @Date: 2021-04-08 15:33:19
 * @LastEditTime: 2021-05-25 15:19:00
 * @LastEditors: Chp
 * @Reference: 
-->
<template>
  <!-- 富文本 -->
  <div class="rich-article">
    <div v-html="html"></div>
  </div>
</template>

<script>
export default {
  props: ['html'],
  data () {
    return {
      html1: `<div class="page-container" style="overflow: auto; text - align: center; "><p style="text-align: left;"><strong><span style="font-size:19px;font-family: '微软雅黑','sans-serif';color:#1F497D">主席团：</span></strong></p><p style="text-align: left;"><span style="font-size: 16px;font-family:'微软雅黑','sans-serif'">俞江林主席&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;黄健龙副主席&nbsp;&nbsp; </span></p><p style="text-align: left;"><span style="font-size:16px;font-family:'微软雅黑','sans-serif'">&nbsp;</span></p><p style="text-align: left;"><strong><span style="font-size:19px;font-family: '微软雅黑','sans-serif';color:#1F497D">第二届理事会成员：</span></strong></p><p style="text-align: left;"><span style="font-size: 16px;font-family:'微软雅黑','sans-serif'">张前理事长&nbsp; &nbsp; &nbsp;</span></p><p style="text-align: left;"><span style="font-size: 16px;font-family:'微软雅黑','sans-serif'">陈昭茹秘书长&nbsp;&nbsp; </span></p><p style="text-align: left;"><span style="font-size: 16px;font-family:'微软雅黑','sans-serif'">林岳理事&nbsp;&nbsp;&nbsp; 姚松君理事&nbsp;&nbsp;&nbsp; 王健理事 &nbsp;&nbsp;&nbsp;田春光理事&nbsp;&nbsp;&nbsp; 黄雅茜理事&nbsp;&nbsp;&nbsp; &nbsp;</span></p><p style="text-align: left;"><span style="font-family:'微软雅黑','sans-serif'">&nbsp;</span></p><p style="text-align: left;"><strong><span style="font-size:19px;font-family: '微软雅黑','sans-serif';color:#1F497D">监事成员：</span></strong></p><p style="text-align: left;"><span style="font-size: 16px;font-family:'微软雅黑','sans-serif'">邵浩泉监事&nbsp; &nbsp; 冯诚监事&nbsp;&nbsp; </span></p><p style="text-align: left;"><strong><span style="font-size:19px;font-family:'微软雅黑','sans-serif';color:#1F497D">&nbsp;</span></strong></p><p style="text-align: left;"><strong><span style="font-size:19px;font-family: '微软雅黑','sans-serif';color:#1F497D">秘书长履历：</span></strong></p><p style="text-align: left;"><span style="font-size: 16px;font-family:'微软雅黑','sans-serif'">陈昭茹女士&nbsp;&nbsp;&nbsp; 2008年任李锦记健康产品集团企业社会责任经理，主要负责集团企业社会责任策略规划、事务统筹与管理，助力企业的可持续发展。2012年起任思利及人公益基金会秘书长，主要负责基金会的规划与日常管理。曾在奥美公共关系及美赞臣营养（中国）有限公司任职。</span></p></div > `
    }
  },
  created () {
  },
  methods: {
  },
}
</script>

<style scoped lang='scss'>
.rich-article {
  padding-top: 20px;
  padding-bottom: 60px;
  /deep/ img {
    max-width: 100%;
  }
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: revert !important;
  font-weight: revert !important;
}
</style>